import React from 'react'
import {Card} from 'antd'
 
const Calendar = () =>{
    return(
       
        <Card title = "Amazon Connect Schedule" style={{ width: '100%'}}>
            <iframe
                src="https://ks-covid-19-hotline.my.connect.aws/agent-app-v2/scheduling"
                title='Amazon Connect Schedule'
                width= '100%'
                height= "600px"
                style={{ border: 'none', overflow: 'hidden'}}
            />
        </Card>
    );
};
export default Calendar;